//**auto-generated don't edit this code**//
export enum Widget {
	None,
	AveragePerformance,
	QuestionsAnswered,
	TimePerQuestion,
	TestsTaken,
	UntestedStudents,
}